import React from 'react';
import classnames from 'classnames';
import { makeStyles, useTheme } from '@material-ui/core';

const styles = makeStyles(() => ({
  confetti: {
    transform: 'scale(0.1)',
    transformOrigin: 'center',
    transformBox: 'fill-box',
  },
  confettiActive: {
    animation: '$animateConfetti 1500ms',
  },
  '@keyframes animateConfetti': {
    '0%': {
      transform: 'scale(0.1)',
    },
    '50%': {
      opacity: 0.7,
    },
    '100%': {
      transform: 'scale(0.8)',
      opacity: 0,
    },
  },
  heart: {
    transformOrigin: 'center',
    transformBox: 'fill-box',
  },
  heartActive: {
    animation: '$animateHeart 1500ms ease-in-out',
  },
  '@keyframes animateHeart': {
    '0%': {
      transform: 'scale(1.0)',
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1.0)',
    },
  },
}));

interface ConfettiHeartProps {
  activateAnimation?: boolean;
}

const ConfettiHeart = ({ activateAnimation = false }: ConfettiHeartProps) => {
  const {
    primary,
    background: { heart },
  } = useTheme<any>().palette;

  const classes = styles();

  const confettiAnimation = classnames([classes.confetti], {
    [classes.confettiActive]: activateAnimation,
  });

  const heartAnimation = classnames([classes.heart], {
    [classes.heartActive]: activateAnimation,
  });

  return (
    <svg viewBox="-1 140 375 180" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g className={confettiAnimation}>
        <rect x="195" y="153.1" width="20.7" height="8.4" rx="4" transform="rotate(-43 195 153)" />
        <rect
          opacity=".9"
          x="230.3"
          y="143.3"
          width="25.8"
          height="10.5"
          rx="4"
          transform="rotate(-23 230.3 143.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="93.4"
          y="230.3"
          width="22.9"
          height="9.3"
          rx="4"
          transform="rotate(-1 93.4 230.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="179.2"
          y="249.8"
          width="16.1"
          height="6.6"
          rx="3.3"
          transform="rotate(153 179.2 249.8)"
          fill={heart}
        />
        <rect
          x="251.4"
          y="249.8"
          width="28.2"
          height="11.4"
          rx="4"
          transform="rotate(25 251.4 249.8)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="106.2"
          y="266.1"
          width="16.1"
          height="6.6"
          rx="3.3"
          transform="rotate(79 106.2 266.1)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="166.4"
          y="267.6"
          width="26.5"
          height="10.8"
          rx="4"
          transform="rotate(106 166.4 267.6)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="277"
          y="291.7"
          width="15.9"
          height="6.5"
          rx="3.2"
          transform="rotate(92 277 291.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="73.5"
          y="51.2"
          width="22.5"
          height="9.1"
          rx="4"
          transform="rotate(-95 73.5 51.2)"
        />
        <rect
          opacity=".8"
          x="102.4"
          y="40.2"
          width="14.7"
          height="6"
          rx="3"
          transform="rotate(-173 102.4 40.2)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="125.2"
          y="38.2"
          width="15.5"
          height="6.3"
          rx="3.1"
          transform="rotate(5 125.2 38.2)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="196.1"
          y="57.2"
          width="14.8"
          height="6"
          rx="3"
          transform="rotate(-119 196.1 57.2)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="233"
          y="72.2"
          width="26.8"
          height="10.9"
          rx="4"
          transform="rotate(100 233 72.2)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="292.9"
          y="47.2"
          width="15.7"
          height="6.4"
          rx="3.2"
          transform="rotate(99 292.9 47.2)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="351.7"
          y="57.2"
          width="14.7"
          height="6"
          rx="3"
          transform="rotate(-150 351.7 57.2)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="7.6"
          y="96.6"
          width="26.5"
          height="10.8"
          rx="4"
          transform="rotate(-91 7.6 96.6)"
          fill={heart}
        />
        <rect
          x="45.5"
          y="88.6"
          width="17.8"
          height="7.2"
          rx="3.6"
          transform="rotate(-75 45.5 88.6)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="104.4"
          y="84.6"
          width="22.2"
          height="9"
          rx="4"
          transform="rotate(122 104.4 84.6)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="129.2"
          y="127.6"
          width="25.2"
          height="10.2"
          rx="4"
          transform="rotate(150 129.2 127.6)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="182.1"
          y="86.6"
          width="21.9"
          height="8.9"
          rx="4"
          transform="rotate(132 182.1 86.6)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="261"
          y="103.6"
          width="19.9"
          height="8.1"
          rx="4"
          transform="rotate(-156 261 103.6)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="303.9"
          y="89.6"
          width="27"
          height="11"
          rx="4"
          transform="rotate(-117 303.9 89.6)"
          fill={heart}
        />
        <rect
          x="375.7"
          y="127.6"
          width="23.1"
          height="9.4"
          rx="4"
          transform="rotate(90 375.7 127.6)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="3.6"
          y="164"
          width="29.6"
          height="12"
          rx="4"
          transform="rotate(132 3.6 164)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="64.5"
          y="149"
          width="17.2"
          height="7"
          rx="3.5"
          transform="rotate(-66 64.5 149)"
          fill={heart}
        />
        <rect x="91.4" y="134" width="19.7" height="8" rx="4" transform="rotate(73 91.4 134)" />
        <rect
          opacity=".8"
          x="160.2"
          y="133"
          width="21.9"
          height="8.9"
          rx="4"
          transform="rotate(-133 160.2 133)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="186.1"
          y="146"
          width="9.5"
          height="3.9"
          rx="1.9"
          transform="rotate(36 186.1 146)"
          fill={heart}
        />
        <rect
          x="248"
          y="154"
          width="13.2"
          height="5.4"
          rx="2.7"
          transform="rotate(-105 248 154)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="314.9"
          y="160"
          width="10.8"
          height="4.4"
          rx="2.2"
          transform="rotate(42 314.9 160)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="335.7"
          y="163"
          width="27"
          height="11"
          rx="4"
          transform="rotate(130 335.7 163)"
          fill={heart}
        />
        <rect
          x="10.6"
          y="184.3"
          width="21.7"
          height="8.8"
          rx="4"
          transform="rotate(112 10.6 184.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="51.5"
          y="174.3"
          width="18.4"
          height="7.5"
          rx="3.7"
          transform="rotate(100 51.5 174.3)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="123.4"
          y="194.3"
          width="12.8"
          height="5.2"
          rx="2.6"
          transform="rotate(3 123.4 194.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="127.2"
          y="197.3"
          width="11.6"
          height="4.7"
          rx="2.4"
          transform="rotate(-159 127.2 197.3)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="177.1"
          y="208.3"
          width="29.9"
          height="12.1"
          rx="4"
          transform="rotate(42 177.1 208.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="246"
          y="184.3"
          width="19.1"
          height="7.7"
          rx="3.9"
          transform="rotate(-175 246 184.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="306.9"
          y="182.3"
          width="18.3"
          height="7.4"
          rx="3.7"
          transform="rotate(-60 306.9 182.3)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="330.7"
          y="186.3"
          width="21"
          height="8.5"
          rx="4"
          transform="rotate(89 330.7 186.3)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="2.6"
          y="256.7"
          width="25.2"
          height="10.2"
          rx="4"
          transform="rotate(-166 2.6 256.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="45.5"
          y="244.7"
          width="12.6"
          height="5.1"
          rx="2.6"
          transform="rotate(155 45.5 244.7)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="87.4"
          y="255.7"
          width="22.2"
          height="9"
          rx="4"
          transform="rotate(41 87.4 255.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="156.2"
          y="244.7"
          width="10.5"
          height="4.3"
          rx="2.1"
          transform="rotate(41 156.2 244.7)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="182.1"
          y="261.7"
          width="21.1"
          height="8.6"
          rx="4"
          transform="rotate(-137 182.1 261.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="273"
          y="221.7"
          width="16.3"
          height="6.6"
          rx="3.3"
          transform="rotate(100 273 221.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="315.9"
          y="236.7"
          width="12.4"
          height="5"
          rx="2.5"
          transform="rotate(-167 315.9 236.7)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="354.7"
          y="240.7"
          width="26.5"
          height="10.8"
          rx="4"
          transform="rotate(84 354.7 240.7)"
          fill={heart}
        />
        <rect
          x="62.5"
          y="265.1"
          width="15.4"
          height="6.3"
          rx="3.1"
          transform="rotate(-104 62.5 265)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="96.4"
          y="292.1"
          width="27.5"
          height="11.2"
          rx="4"
          transform="rotate(161 96.4 292)"
          fill={heart}
        />
        <rect
          x="143.2"
          y="297.1"
          width="21.5"
          height="8.7"
          rx="4"
          transform="rotate(-38 143.2 297)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="202.1"
          y="272.1"
          width="28.2"
          height="11.4"
          rx="4"
          transform="rotate(82 202.1 272)"
          fill={heart}
        />
        <rect
          x="248"
          y="273.1"
          width="14"
          height="5.7"
          rx="2.9"
          transform="rotate(-177 248 273)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="285.9"
          y="281.1"
          width="20.7"
          height="8.4"
          rx="4"
          transform="rotate(59 285.9 281)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="340.7"
          y="277.1"
          width="19.3"
          height="7.9"
          rx="3.9"
          transform="rotate(-6 340.7 277)"
          fill={heart}
        />
        <rect
          x="39.5"
          y="342.5"
          width="18.1"
          height="7.4"
          rx="3.7"
          transform="rotate(-135 39.5 342.5)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="74.4"
          y="312.5"
          width="11.1"
          height="4.5"
          rx="2.3"
          transform="rotate(-134 74.4 312.5)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="142.2"
          y="327.5"
          width="21.1"
          height="8.6"
          rx="4"
          transform="rotate(54 142.2 327.5)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="194.1"
          y="348.5"
          width="18.9"
          height="7.7"
          rx="3.8"
          transform="rotate(138 194.1 348.5)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="276"
          y="347.5"
          width="19.7"
          height="8"
          rx="4"
          transform="rotate(31 276 347.5)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="322.9"
          y="342.5"
          width="10.6"
          height="4.3"
          rx="2.2"
          transform="rotate(-141 322.9 342.5)"
          fill={heart}
        />
        <rect
          opacity=".7"
          x="340.7"
          y="350.5"
          width="25"
          height="10.1"
          rx="4"
          transform="rotate(30 340.7 350.5)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="-.4"
          y="369.8"
          width="14.9"
          height="6.1"
          rx="3"
          transform="rotate(-60 -.4 369.8)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="47.5"
          y="385.8"
          width="15"
          height="6.1"
          rx="3"
          transform="rotate(168 47.5 385.8)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="94.4"
          y="363.8"
          width="17"
          height="6.9"
          rx="3.4"
          transform="rotate(-67 94.4 363.8)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="158.2"
          y="364.8"
          width="13.7"
          height="5.6"
          rx="2.8"
          transform="rotate(124 158.2 364.8)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="193.1"
          y="386.8"
          width="22"
          height="8.9"
          rx="4"
          transform="rotate(100 193.1 386.8)"
          fill={heart}
        />
        <rect
          opacity=".9"
          x="250"
          y="364.8"
          width="16.5"
          height="6.7"
          rx="3.3"
          transform="rotate(82 250 364.8)"
          fill={heart}
        />
        <rect
          opacity=".8"
          x="292.9"
          y="388.8"
          width="30.7"
          height="12.5"
          rx="4"
          transform="rotate(64 292.9 388.8)"
          fill={heart}
        />
        <rect
          x="375.7"
          y="398.8"
          width="22"
          height="8.9"
          rx="4"
          transform="rotate(87 375.7 398.8)"
          fill={heart}
        />
      </g>
      <g className={heartAnimation}>
        <path
          fill={heart}
          d="M245.6 157.4c-11-10.5-29.5-7.2-40.2 3.5-10.7 10.8-15.3 17.3-17.1 32.7a49 49 0 0 0-20.5-30.3c-12-8.8-31.8-7-41 4.8-6.4 8-7 19.7-4.2 29.6 2.8 10 8.7 18.7 14.4 27.2l50.6 75a2.5 2.5 0 0 0 4.3 0 1136 1136 0 0 0 50.2-84.4c4.9-9.2 9.7-18.7 11.4-29 1.6-10.4-.5-22-8-29Z"
        />
        <path
          fill={primary.main}
          d="M206.4 250.8c.6 0 1.4.3 1.9 0 .7-.2 1.7-2.2 1.3-3a44.7 44.7 0 0 0-13.6-5.4c-1-.2-2-.2-3.2-.5l-3.5-.2c-.3 0-.7 0-1-.2-.5-.3 0-.9.2-1.3 1.8-2.6 3.1-5.5 5-8 1.4-2 3.4-4.6 4.5-6.9 1.3-2.7 2.8-4.6 4.5-6.8.7-1 1.7-2.2 2.1-3 .9-1.5 1.8-3 2.9-4.3.6-.8 1.4-1.4 1.4-2.5-1.2-1-2.6-3-4.3-2.5-2.7.7-5.4.7-8 .6l-2-.3-1.7-.3-4.7-1a27 27 0 0 0-8.6-.3c-2.9.3-7.6 2-8.4 4.8-.4 1.3-1.4 2.6-.8 4.1 3.2.4 6.4.5 9.7.5 2.8.2 5.4-.5 8.3.1 1 .2 3-.2 4 .4-2 3-4.3 5.8-6.6 8.5a42.6 42.6 0 0 0-4.1 5.4c-1.6 2.6-3.4 4.4-4.1 5.2-3.2 3.7-7 8.6-8 10-1 1.5-2.7 3.4-3.2 4.7-.3 1 .3 2.4 1.3 2.9.4.7 1.2 1.2 1.8 1.8 2.5 1.2 5 1.3 7.6.8l2-.4c3.8-.8 7.9-1.2 11.6-2.2l3-.4c3.1-.5 6-.3 8.8-.5 1.3 0 2.6 0 3.9.2Z"
        />
      </g>
    </svg>
  );
};

export default ConfettiHeart;
